import { motion } from "framer-motion";

import { useLanguage } from "../i18n/LanguageContext";
import { LANGUAGES, LANGUAGE_LABELS } from "../i18n/strings";
import "./LangSwitch.css";

/** DE · EN · FR as a segmented pill; the active segment slides. */
export default function LangSwitch({ tone = "dark" }: { tone?: "dark" | "light" }) {
  const { language, setLanguage, t } = useLanguage();

  return (
    <div className={`lang lang-${tone}`} role="group" aria-label={t("language")}>
      {LANGUAGES.map((code) => {
        const active = code === language;
        return (
          <button
            key={code}
            className={`lang-btn${active ? " is-active" : ""}`}
            onClick={() => setLanguage(code)}
            aria-pressed={active}
            aria-label={LANGUAGE_LABELS[code]}
            lang={code}
          >
            {active && (
              <motion.span
                layoutId={`lang-pill-${tone}`}
                className="lang-pill"
                transition={{ type: "spring", stiffness: 420, damping: 36 }}
              />
            )}
            <span className="lang-code">{code.toUpperCase()}</span>
          </button>
        );
      })}
    </div>
  );
}
